import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { PAGE_PARAMS } from "../../Helpers/constants";

function PageRoutes({ programTypeValue }: { programTypeValue: string }) {
  useEffect(() => {
    const paramKeys = Object.keys(PAGE_PARAMS);
    if (paramKeys.includes(programTypeValue)) {
      localStorage.setItem("programType", PAGE_PARAMS[programTypeValue]);
      localStorage.setItem("programTypeValue", programTypeValue);
    }
  }, [programTypeValue]);

  return <Outlet />;
}

export default PageRoutes;
